const getSizeMappingIndex = ({ adverts: { sizeMappingIndex } }) =>
  sizeMappingIndex;

export default getSizeMappingIndex;
